import get from 'lodash/get';
import first from 'lodash/first';

export const SatisfactionForm = data => ({
  id: data.id,
  introduction: data.introduction,
  ratingPrompt: data.ratingPrompt,
  questions: data.questions,
  scaleLabelHigh: data.scaleLabelHigh,
  scaleLabelLow: data.scaleLabelLow,
  scaleType: data.scaleType,
  scaleOptions: data.scaleOptions,
});

export const sessionData = data => ({
  satisfactionId: data.satisfactionId,
  satisfactionStatus: data.satisfactionStatus,
  satisfactionLockedAt: data.satisfactionLockedAt ? Date.parse(data.satisfactionLockedAt) : null,
});

export const responseDataToSatisfactionForm = responseData => {
  const form = first(responseData.included) || {};

  return {
    satisfactionForm: new SatisfactionForm({
      id: get(responseData, 'data.id'),
      introduction: get(form, 'attributes.introduction'),
      ratingPrompt: get(form, 'attributes.ratingPrompt'),
      questions: get(form, 'attributes.questions'),
      scaleLabelHigh: get(form, 'attributes.scale.labelHigh'),
      scaleLabelLow: get(form, 'attributes.scale.labelLow'),
      scaleType: get(form, 'attributes.scale.type'),
      scaleOptions: get(form, 'attributes.scale.options'),
      lockedAt: get(responseData, 'data.attributes.lockedAt'),
    }),
    session: sessionData({
      satisfactionId: get(responseData, 'data.id'),
      satisfactionStatus: get(responseData, 'data.attributes.status'),
      satisfactionLockedAt: get(responseData, 'data.attributes.lockedAt'),
    }),
  };
};

export const responseToSatisfactionForm = response => {
  return responseDataToSatisfactionForm(response.data);
};
